<template>
  <div>
    <GroupMasterLayout>
      <section class="overhead">
        <div
          class="overhead-1 d-flex justify-content-between py-5 wallet-header"
        >
          <div>
            <h5 class="">{{ $t("text.iGroup.wallet") }}</h5>

            <h6>{{ $t("text.iGroup.viewBranchHistory") }}</h6>
          </div>
          <div class="col-md-4 date_picker_m">
            <div class="">
              <vue-ctk-date-time-picker
                v-model="dateRange"
                :max-date="maxDate"
                :range="true"
                :autoClose="true"
                :locale="this.$root.$i18n.locale"
                :custom-shortcuts="customShortcuts"
                color="#370F70"
                format="DDMMYYYY"
                formatted="DD/MM/YYYY"
                :label="$t('text.calendar.dateRange')"
              />
            </div>
          </div>
        </div>

        <div class="sub-nav">
          <ul class="d-flex">
            <li
              @click="() => (tabName = 'overview')"
              :class="tabName === 'overview' ? 'active-nav' : null"
              class="mr-5 pb-3 px-1"
            >
              {{ $t("text.iGroup.walletOverview") }}
            </li>
            <li
              @click="() => (tabName = 'transDetails')"
              :class="tabName === 'transDetails' ? 'active-nav' : null"
            >
              {{ $t("text.iGroup.transactionDetails") }}
            </li>
          </ul>
        </div>
      </section>
      <OverviewTab
        :dateRange="dateRange"
        :maxDate="maxDate"
        :startDatee="startDate"
        :endDatee="endDate"
        v-show="tabName === 'overview'"
      />
      <TransactionDetails
        :dateRange="dateRange"
        :maxDate="maxDate"
        :startDatee="startDate"
        :endDatee="endDate"
        v-show="tabName === 'transDetails'"
      />
    </GroupMasterLayout>
  </div>
</template>

<script>
import GroupMasterLayout from "@/views/Industrial/GroupMasterLayout.vue";
import OverviewTab from "./Overview";
import TransactionDetails from "./TransactionDetails";
export default {
  title: "Dashboard:: Epump Industrial Portal",
  name: "WalletOverview",
  components: {
    GroupMasterLayout,
    OverviewTab,
    TransactionDetails,
  },
  data() {
    return {
      tabName: "overview",
      startDate: this.$moment().subtract(7, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange: { start: this.pluginStartDate, end: this.pluginEndDate },
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
    };
  },
};
</script>

<style scoped>
@media screen and (max-width: 575px) {
  .overhead-1 {
    flex-flow: column wrap !important;
  }
  .sub-nav li {
    font-size: 13px !important;
  }
}
.wallet-header {
  width: 90%;
  margin: auto auto;
}

.overhead h5 {
  color: #2b2b2b;
  font-size: 35px;
}

.overhead ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 92%;
  margin: auto auto;
}

.sub-nav li {
  color: #2b2b2b;
  font-size: 14px;
  cursor: pointer;
}

.active-nav {
  color: #370f70 !important;
  border-bottom: 2px solid #370f70;
}

.sub-nav {
  width: 98%;
  margin: auto auto;
  border-bottom: 1px solid rgba(98, 98, 98, 0.2);
}
</style>
